<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-card__header mt-3">
				<div class="d-flex align-items-end">
					<!--작업내용-->
					<span class="title"><i class="sf-icon icon-sf-caret-right" />{{ getMessage_('QWCC001859') }}</span>
				</div>
			</div>

			<template>
				<sf-data-table
					ref="clamMstTable"
					:paging="false"
					:columns="mkObjSwapPartsCols"
					:rows="rows"
					:excel="false"
					:stripe="false"
					:addRowData="addRowData"
					fit
					:selection="false"
					height="300px"
				>
				</sf-data-table>
			</template>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../../store/helpers';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	components: {},
	data() {
		return {
			addRowData: {
				//행추가 이벤트시 필요한부분
				rowType: 'add',
				partNo: '',
				partNm: '',
				qty: '',
				partCst: ''
			},
			searchStye: {
				//그리드 버튼 스타일 지정
				top: '8px',
				right: '7px'
			},
			partNoInput: '', //품번팝업 호출시 매개체
			selGridRowIndex: ''
		};
	},
	computed: {
		...rootComputed,
		...serviceComputed,

		rows() {
			//그리드 로우
			return this.mkObjSwapPartsList;
		},
		mkObjSwapPartsCols() {
			//그리드 컬럼
			return [
				{
					label: '* ' + this.getMessage_('QWCC001037'), // END 품번
					prop: 'partNo',
					width: '150px',
					headerAlign: 'center',
					sortable: false
				},
				{
					label: this.getMessage_('QWCC000957'), //품명
					prop: 'partNm',
					width: '250px',
					headerAlign: 'center',
					sortable: false,
					form: {
						type: 'input',
						isDisabled: () => true
					}
				},
				{
					label: this.getMessage_('QWCC001096'), //OP코드
					prop: 'opCd',
					width: '100px',
					align: 'center',
					isDisabled: () => true
				},
				{
					label: this.getMessage_('QWCC001807'), //OP코드명
					prop: 'opNm',
					width: '200px',
					headerAlign: 'center',
					isDisabled: () => true
				},
				{
					label: this.getMessage_('QWCC001040'), // 부품가격
					prop: 'partCst',
					width: '120px',
					sortable: false,
					form: {
						type: 'number',
						isDisabled: () => true
					}
				},

				{
					label: this.getMessage_('QWCC000977'), // 교환부품수량
					prop: 'qty',
					width: '130px',
					sortable: false,
					form: {
						type: 'number',
						isDisabled: () => true
					}
				},
				{
					label: this.getMessage_('QWCC001101'), // 자재비
					prop: 'amt',
					width: '100px',
					sortable: false,
					form: {
						type: 'number',
						isDisabled: () => true
					}
				},
				{
					label: this.getMessage_('QWCC001100'), //LTS
					prop: 'lts',
					width: '100px',
					sortable: false,
					isDisabled: () => true
				},
				{
					label: this.getMessage_('QWCC001861'), // 기준금액
					prop: 'stdCst',
					width: '100px',
					sortable: false,
					form: {
						type: 'number',
						isDisabled: () => true
					}
				},
				{
					label: this.getMessage_('QWCC001102'), // 공임비
					prop: 'wags',
					minWidth: '100px',
					sortable: false,
					form: {
						type: 'number',
						isDisabled: () => true
					}
				}
			];
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') {
				return false;
			} else {
				return true;
			}
		},
		addGirdAction() {
			//행추가
			let addRowData = { ...this.addRowData };
			this.rows.unshift(addRowData);
			this.$refs.clamMstTable.getTable().toggleRowSelection(addRowData);
			/*
			setTimeout(() => {
				let node = document.querySelector('.el-table__body-wrapper tbody > tr:nth-of-type(1) > td:nth-of-type(3) input');
				node.focus();
			}, 1);
			*/
		},
		onCausePartPopup(param) {
			//console.log('파람>>>>>', param);
			//console.log('this.roApcnPopUp.readOnlyAuth1>>>>>', this.roApcnPopUp.readOnlyAuth1);

			if (this.roApcnPopUp.readOnlyAuth1 == false) {
				//원인부품명
				this.partNoInput = param.row.partNo;
				this.selGridRowIndex = param.index; //그리드에서 선택한 해당행의 인덱스.

				this.$emit('OpenGridPartPopup', this.partNoInput); //상위(Content.vue)에 정의한  PopUpOpen함수를 실행한다.
			}
		},
		deleteGridAction() {
			//delete버튼
			//console.log('@@@@ delete action');
			//const selected = this.$refs.clamMstTable.getSelectedRows();

			if (selected.length < 1) {
				this.$sf_showMessage({
					icon: 'error',
					title: this.getMessage_('MWCC000109'),
					message: this.getMessage_('MWCC000110')
				}); //행을 선택해 주세요. / 선택된 데이터가 없습니다.
				return;
			}

			let tmpRoNo = this.roApcnPopUp.roNo || '';

			let delValiGb = false;

			//PWA에서 넘어온행들은 먼저 저장을 해야됩니다.
			if (tmpRoNo === '') {
				delValiGb = true;
			}

			this.$refs.clamMstTable.multipleSelection.forEach(row => {
				if (row.rowType === 'add') {
					delValiGb = true;
				}
			});

			if (delValiGb === true) {
				this.$sf_toast({ type: 'error', message: this.getMessage_('QWCC000917') });
				return false;
			}

			try {
				//컨펌창
				this.$sf_showMessage({
					type: 'confirm',
					icon: 'confirm',
					title: this.getMessage_('MWCC000108'), //삭제하시겠습니까?
					buttons: [{ title: this.getMessage_('MWCC000107'), clickFn: () => this.remove(selected) }] //삭제
				});
			} catch (error) {
				this.$sf_toast({ type: 'error', message: error.message });
				return false;
			}
		},
		remove(selected) {
			//console.log('@@@@ delete');

			this.$sf_toggleLoading(true);
			this.delApcnRoSwapInfoList_(selected)
				.then(response => {
					if (response.message != undefined && response.message != null) {
						this.$sf_toast({
							type: response.code === 0 ? 'ok' : 'error',
							message: this.getMessage_(response.messageCd)
						});
					}
					// this.$refs.varTable.deleteHandler(false);
					this.resetSelection();
				})
				.catch(error => {
					this.$sf_toast({
						type: 'error',
						message: error.message
					});
					Promise.reject(error);
				})
				.finally(() => {
					this.$sf_toggleLoading(false);
				});
		},
		resetSelection() {
			//체크박스 해제
			let checkedCount = document.getElementsByClassName('is-checked').length;
			for (let i = 0; i < checkedCount; i++) {
				document.getElementsByClassName('is-checked')[0].classList.remove('is-checked');
			}

			//this.$emit('Refresh');
		},
		gridParNoPopUp(param) {
			//console.log('값은1>>>>>>>>>>>>>>', param);
			//console.log('그리드에서 선택한 인덱스값>>>>>>>>>>>>>>>>', this.selGridRowIndex);

			let dataArr = this.roApcnSwapPartsList.slice();
			dataArr[this.selGridRowIndex].partNo = param.partNo;
			dataArr[this.selGridRowIndex].partNm = param.partNm;
		},
		gridCheckRowData() {
			/* 상위 저장 버튼시 이 함수를 호출함 체크된행만 리턴함*/
			return this.$refs.clamMstTable.getSelectedRows();
		},

		/*******************************************얼그레이아이스티 ******************************/
		//캠페인 선택 교환부품목록 세팅
		seletedCmpnNo() {
			this.DEFAULT_ASSIGN({
				key: 'popupSelected',
				value: this.cmpnMstPartSelected
			});

			this.seletedPartNoList();
		},
		deletePartList() {
			this.DEFAULT_ASSIGN({
				key: 'popupSelected',
				value: []
			});
		},
		seletedPartNoList() {
			this.DEFAULT_ASSIGN({
				key: 'roApcnSwapPartsList',
				value: this.popupSelected
			});
		}
		/********************************************얼그레이아이스티 ******************************/
	},
	watch: {
		//삭제Flag
		isDelPwaCompInitFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.isDelPwaCompInitFlag) {
				this.deletePartList();
			}
		},
		isDelCamPaignCompInitFlag() {
			// true 일때 해당 data를 store에 담는 작업 시작
			if (this.isDelCamPaignCompInitFlag) {
				this.deletePartList();
			}
		}
	}
};
</script>
